import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-forcer-mot-passe',
    templateUrl: './forcer-mot-passe.component.html',
    styleUrls: ['./forcer-mot-passe.component.scss'],
    imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule
]
})
export class ForcerMotPasseComponent {
  email: string = '';
  motDePasse: string = '';
  isLoading: boolean = false;

  constructor(
    private utilisateurService: UtilisateurService,
    private snackBar: MatSnackBar
  ) { }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  forcerMotDePasse(): void {
    if (!this.email || !this.isValidEmail(this.email)) {
      this.snackBar.open('Veuillez entrer une adresse email valide', 'Fermer', { duration: 3000 });
      return;
    }

    if (!this.motDePasse || this.motDePasse.length < 8) {
      this.snackBar.open('Le mot de passe doit contenir au moins 8 caractères', 'Fermer', { duration: 3000 });
      return;
    }

    this.isLoading = true;

    this.utilisateurService.forcerMotDePasseParEmail(this.email, this.motDePasse).subscribe({
      next: () => {
        this.snackBar.open('Mot de passe forcé avec succès', 'Fermer', { duration: 5000 });
        this.email = '';
        this.motDePasse = '';
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {

        if(error.status === 400){
          this.snackBar.open(
            'Erreur lors du forçage du mot de passe:',
            'Fermer',
            { duration: 5000 }
          );
        }
        console.error('Erreur lors du forçage du mot de passe:', error);
        this.isLoading = false;
      }
    });
  }
}
